import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { NomenclatureItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-items-page.dto';
import type { NomenclatureRegistryQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-registry-query.dto';
import type { NomenclatureTreeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-tree-find.dto';
import type { NomenclatureTreeQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-tree-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NomenclatureTreeService extends BaseService {
  protected baseUrl = '/basis/catalog/nomenclature';

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: NomenclatureRegistryQueryInterface): Observable<NomenclatureItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<NomenclatureItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findTree(queryParams?: NomenclatureTreeQueryInterface): Observable<NomenclatureTreeFindInterface[]> {
    return this.findPage(queryParams).pipe(map((page) => page.items ?? []));
  }
}
